
import clsx from "clsx";
import React, { Component } from "react";
import App from "../../App";
import { IPopupType } from "../../interfaces/ILabyData";
import { IPopupManagerProps } from './IPopupManagerProps';
import PopupFinPartie from "./PopupFinPartie/PopupFinPartie";
import PopupQuestion from "./PopupQuestion/PopupQuestion";
import PopupQuitter from "./PopupQuitter/PopupQuitter";
import { TPopupManagerState } from './TPopupManagerState';



class PopupManager extends Component<IPopupManagerProps,any> {

  app:App;
  
  
  constructor(props:any){
    super(props);
    this.app = props.app;
  }

  state:TPopupManagerState = this.getInitialState();
  getInitialState():TPopupManagerState{
    return{
      popupQuitterOuvert:false,
      popupQuestionOuvert:false,
      popupFinPartieOuvert:false,
      currentQuestionBaseInfo:{valeur:0, code:"1"},
      currentFinPartieInfo:{valeur:0, niveau:1}
    }
  }

  componentDidMount(){
      
  }

  openPopup(lequel:IPopupType="", param:any={}){
    this.app.gameManager.current?.onPopupOpen(lequel);
    switch(lequel){
      case "quitter":
        this.setState({popupQuitterOuvert:true, popup_ouvert:true});
        window.scrollTo(0, 0);  
      break;
      case "question":
        this.setState({popupQuestionOuvert:true, popup_ouvert:true, currentQuestionBaseInfo:param});
        window.scrollTo(0, 0);  
      break;
      case "fin_partie":      
        this.setState({popupFinPartieOuvert:true, popup_ouvert:true, currentFinPartieInfo:param});
        window.scrollTo(0, 0);  
      break;
    }
  }

  public closePopup(lequel:IPopupType, param:string=""){
    switch(lequel){
      case "question":
        this.setState({popupQuestionOuvert:false});
      break;
      case "fin_partie":
        this.app.gameManager.current?.retournerVersIntro();
        this.setState({popupFinPartieOuvert:false});   
      break;
      case "quitter":
        if (param === "oui"){
          this.app.gameManager.current?.retournerVersIntro();
        }
        this.setState({popupQuitterOuvert:false});
      break;      

    }
    this.app.gameManager.current?.onPopupClosed(lequel);
  }



  render() {
    const unPopupOuvert = (this.state.popupQuestionOuvert || this.state.popupFinPartieOuvert|| this.state.popupFinPartieOuvert || this.state.popupQuitterOuvert)
       
    return (
        <div className={
            clsx(
              "popup_overlay",
              (unPopupOuvert && "ouvert"),
              (this.state.popupQuestionOuvert && "question"),
              (this.state.popupFinPartieOuvert && "fin_partie"),
              (this.state.popupQuitterOuvert && "quitter")
            )
        }>
            {this.state.popupQuestionOuvert && (
              <PopupQuestion pm={this} valeur={this.state.currentQuestionBaseInfo.valeur} code={this.state.currentQuestionBaseInfo.code} />
            )}
            {this.state.popupFinPartieOuvert && (
              <PopupFinPartie pm={this} valeur={this.state.currentFinPartieInfo.valeur} niveau={this.state.currentFinPartieInfo.niveau} />
            )}
            
            {this.state.popupQuitterOuvert && (
              <PopupQuitter pm={this} />
            )}
           
            
        </div>
    )
  }

}

export default PopupManager;
